<template>
    <div>
       
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="queryParams" inline label-position="right" label-width="80px" v-model="queryParams">
                <el-form-item label="商户号">
                    <el-input size="small" v-model="queryParams.userId" placeholder="商户号" style="width: 120px" />
                </el-form-item>
                <el-form-item label="商户名">
                    <el-input size="small" v-model="queryParams.userName" placeholder="商户名" style="width: 120px" />
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input size="small" v-model="queryParams.phone" placeholder="手机号码" style="width: 120px" />
                </el-form-item>
                <el-form-item label="账号状态">
                    <el-select size="small"  v-model="queryParams.state" style="width:120px">
                        <el-option value="" label="全部状态">全部状态</el-option>
                        <el-option value="1" label="正常">正常</el-option>
                        <el-option value="0" label="已禁用">已禁用</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
            <Table size="large" :loading="loading" :columns="columns" :data="merchants" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
        <Modal title="编辑" v-model="modalEdit" :closable="false" :mask-closable="false">
            <el-form ref="merchant" label-position="right" label-width="120px" :model="merchant" :rules="rules">
                <input type="hidden" :model="merchant.id" />
                <el-form-item label="商户名" prop="merName">
                    <el-input size="small" v-model="merchant.merName" :disabled="merchant.id>0" placeholder="商户名" style="width: 240px" />
                </el-form-item>
                <el-form-item label="昵称" prop="name">
                    <el-input size="small" v-model="merchant.name" :disabled="merchant.id>0" placeholder="昵称" style="width: 240px" />
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input size="small" v-model="merchant.phone" :disabled="merchant.id>0" placeholder="手机号码" style="width: 240px" />
                </el-form-item>
                <el-form-item label="基础手续费" prop="baseFee">
                    <el-input size="small" v-model="merchant.baseFee" placeholder="单件手续费" style="width: 240px" />
                </el-form-item>
                <el-form-item label="验货手续费" prop="inspFee">
                    <el-input size="small" v-model="merchant.inspFee" placeholder="验货手续费" style="width: 240px" />
                </el-form-item>
                <el-form-item label="包裹加价" prop="increateFee">
                    <el-input size="small" v-model="merchant.increateFee" placeholder="验货手续费" style="width: 240px" />
                </el-form-item>
                <template v-if="!merchant.id">
                    <el-form-item label="登录密码" prop="passport">
                        <el-input size="small" v-model="merchant.passport" placeholder="密码" style="width: 240px" />
                    </el-form-item>
                </template>
                <el-form-item label="登录状态" prop="state">
                    <RadioGroup v-model="merchant.state" placeholder="状态" style="width: 240px">
                        <Radio :label="1">
                            <span>启用</span>
                        </Radio>
                        <Radio :label="0">
                            <span>禁用</span>
                        </Radio>
                    </RadioGroup>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" :loading="modalLoading" @click="ok">确定</el-button>
            </div>
        </Modal>
        <CPassword v-bind:show="modalPwdEdit" v-bind:userId="merchant.id" v-on:ok="pwdOk" @cancel="pwdCancel">
        </CPassword>
    </div>
</template>
<script>
import CPassword from '../Merchant/CPassword.vue'


export default {
    name: 'Merchant',
    data() {
        return {
            loading: false,
            modalEdit: false,
            modalLoading: false,

            modalPwdEdit: false,


            queryParams: {

            },


            merchant: {
                id: 0,
                dfState: '1',
                state: '1'
            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            merchants: [

            ],
            rules: {
                
                dfState: [{
                    required: true,
                    message: "",
                }],
                state: [{
                    required: true,
                    message: "",
                }],
                passport: [{
                    required: true,
                    message: "登录密码不能为空",
                }],
                baseFee: [{
                    required: true,
                    message: "基础费用不能为空",
                }],
                inspFee: [{
                    required: true,
                    message: "验货费用不能为空",
                }],
                increateFee: [{
                    required: true,
                    message: "加价费用不能为空",
                }]
            },

            columns: [{
                title: '登录名',
                key: 'id',
                width: 180,
                align: 'center',
                fixed: 'left',
                render: (h, params) => {
                    var row = params.row;
                    var btns = [

                    ];
                    if (row.credit == 1) {
                        btns.push(h("div", { style: { margin: "5px", color: "#f00" } }, "可赊账"));
                    }
                    btns.push(h("div", { style: { margin: "5px" } }, row.merName));
                    btns.push(h("div", { style: { color: "#f00" } }, params.row.id));
                    return h("div", btns);
                }
            }, {
                title: '昵称',
                key: 'name',
                width: 150,
                align: 'center',
                fixed: 'left',
                render: (h, params) => {
                    return h("div", [

                        h("div", { style: { margin: "5px" } }, params.row.name)
                    ]);
                }
            }, {
                title: '手机号码',
                key: 'phone',
                width: 130,
                align: 'center'
            }, {
                title: '手续费',
                key: 'baseFee',
                width: 130,
                align: 'center',
                render: (h, params) => {
                    var row = params.row;
                    var btns = [];
                    var styles = {};
                    btns.push(h("div", { style: styles }, "基  础：" + row.baseFee + "元"));
                    btns.push(h("div", { style: styles }, "验  货：" + row.inspFee + "元"));
                    btns.push(h("div", { style: styles }, "包裹加价：" + row.increateFee + "元"));
                    return h("div", btns);
                }
            }, {
                title: '账户余额',
                key: 'account',
                width: 130,
                align: 'center'
            }, {
                title: '登录状态',
                key: 'state',
                width: 130,
                align: 'center',
                render: (h, params) => {
                    var row = params.row;
                    var text = "启用";
                    var styles = { color: '#fff', padding: '2px' };
                    if (row.state == 0) {
                        text = "禁用";
                        styles.backgroundColor = "#bbbec4";
                    } else {
                        styles.backgroundColor = "#5cb85c";
                    }
                    return h("div", [
                        h("span", { style: styles }, text)

                    ]);
                }
            }, {
                title: '操作',
                key: 'state',
                width: 340,
                align: 'center',
                fixed: 'left',
                render: (h, params) => {
                    var row = params.row;

                    var btn = [];


                    btn.push(
                        h("Button", {
                            props: {
                                type: row.state != 1 ? "primary" : "error",
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.userState(row, row.state == 1 ? 0 : 1);
                                }
                            },
                            style: { marginRight: '5px' }
                        }, row.state != 1 ? "启用" : "禁用")
                    );
                    btn.push(h("Button", {
                        props: {
                            type: "primary",
                            size: 'small'
                        },
                        nativeOn: { click: () => { this.edit(row); } }
                    }, "修改资料"));



                    btn.push(h("Button", {
                        props: {
                            type: "success",
                            size: 'small'
                        },
                        nativeOn: { click: () => { this.editPwd(row); } }
                    }, "修改密码"));

                     btn.push(h("Button", {
                        props: {
                            type: "success",
                            size: 'small'
                        },
                        nativeOn: { click: () => { this.viewPwd(row); } }
                    }, "查看密码"));

                    return h("div", btn);
                }
            }, {
                title: '最后登录时间',
                key: 'lastLoginTime',
                width: 150,
                align: 'center',
                render: (h, params) => {
                    var me = this;
                    return h("div", [
                        h("span", { style: {} }, me.long2datetime(params.row.lastLoginTime))
                    ]);
                }
            }, {
                title: '注册时间',
                key: 'createTime',
                width: 150,
                align: 'center',
                render: (h, params) => {
                    var me = this;
                    return h("div", [
                        h("span", { style: {} }, me.long2datetime(params.row.createTime))
                    ]);
                }
            }]
        };
    },
    mounted: function() {
        this.getList();

    },
    components: {
        CPassword,

    },
    methods: {
        ch: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
          search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = {};
            this.getList();
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        userState: function(user, state) {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行该操作",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/merchant/state.action", { id: user.id, state: state }).then(response => {
                        var body = response;
                        if (body.status == 0) {
                            user.state = state;

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                        me.hideLoading();
                    }, response => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/merchant/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.page.total = body.obj.totalCount;
                    me.merchants = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        edit: function(row) {
            this.merchant = row;
            this.modalEdit = true;
        },
        ok: function() {
            var ok = false;
            this.$refs['merchant'].validate((valid) => {
                ok = valid;
                if (valid) {

                } else {
                    this.$Message.error('请认真填写数据');
                }
            })
            if (!ok) return;
            var me = this;

            me.modalLoading = true;
            // var pd = { phone: me.merchant.phone, id: me.merchant.id };
            me.$http.post("/ware/merchant/doSave.action", me.merchant).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.$Message.success("保存成功！");
                    me.getList();
                    me.modalEdit = false;

                } else {
                    me.$Message.error("操作异常!" + body.info);
                }
                me.modalLoading = false;
            }, response => {
                me.modalLoading = false;
            });
        },
        cancel: function() {

            this.modalEdit = false;
        },
        editPwd: function(row) {
            this.merchant.id = row.id;
            this.modalPwdEdit = true;
        },
        viewPwd:function(row){

        },
        pwdOk: function() {
            this.modalPwdEdit = false;
        },
        pwdCancel: function() {

            this.modalPwdEdit = false;
        }
    }
}
</script>
<style scoped>
.ivu-table table {
    min-height: 500px;
}
</style>